import useSWR from 'swr'
import { client } from '~editor/utils/gg_client'

const fetcher = (url: string) => client(url).then((res) => res.data)

export const useSWRHelper = (url?: string | null | false) => {
  const swr = useSWR(url || null, fetcher)

  return swr
}

export default useSWRHelper
